// extracted by mini-css-extract-plugin
export var button = "_bd-0";
export var icon = "_bd-1";